export const platformAiSuite = {
  id: 7,
  title: "Platform AI-Suite",
  activityId: [6, 7],
  startDate: '2024-01-01',
  endDate: null,
  description: "AI-Suite for the data platform, leveraging intelligence for improved data insights",
  categorizedSkills: {
    profession: [
      { name: "AI", weight: 1 },
      { name: "Natural Language Processing", weight: 0.9 },
      { name: "Software Development", weight: 0.8 },
      { name: "RAG Architecture", weight: 1 }
    ],
    language: [
      { name: "Python", weight: 0.9 },
      { name: "SQL", weight: 0.8 }
    ],
    tools: [
      { name: "OpenAI", weight: 0.8 }
    ],
    lead: []
  },
  goal: "Create an intuitive AI-Suite for employees to work with company data using natural language.",
  detailsFile: "platform-ai-suite.md", // Reference to markdown file
  metrics: [],
  role: "AI Solutions Architect",
  teamSize: "3",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: true
};
